import React, { useCallback, useState } from 'react';
import MobileButtonsListContent from './mobile-buttons-list.content';
import { PORTAL_TYPE } from '../../../types/app.types';
import { buttonListData } from '../buttons-list.data';

const MobileButtonsList: React.FunctionComponent = () => {
  const [activeItem, setActiveItem] = useState<PORTAL_TYPE | null>();

  const toggleButton = useCallback((id) => {
    setActiveItem((prevValue) => (prevValue !== id ? id : null));
  }, []);

  return (
    <MobileButtonsListContent
      items={buttonListData}
      activeItem={activeItem}
      toggleButton={toggleButton}
    />
  );
};
export default MobileButtonsList;
